export default __webpack_public_path__ + "static/media/480_dummy2016-weinhandel01-de.3061ca94.png";